import { DatePipe } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { mergeMap, tap } from 'rxjs/operators';
import { BriefingService, UserService } from '../services';

@Component({
    selector: 'briefing-teams-settings-editor',
    template: `
        <div style="padding: 20px;" fxLayout="column" fxLayoutAlign="space-evenly">
            <div fxLayout="column">
                <mat-form-field [formGroup]="form">
                    <input matInput type="text" placeholder="Title" formControlName="briefingTitle">
                    <mat-error *ngIf="form.get('briefingTitle').hasError('required')">Title cannot be blank</mat-error>
                </mat-form-field>
                <mat-form-field [formGroup]="form">
                    <input matInput type="text" placeholder="Description" formControlName="description">
                    <mat-error *ngIf="form.get('description').hasError('required')">Description cannot be blank</mat-error>
                </mat-form-field>
                <mat-form-field *ngIf="created">
                    <input matInput type="text" placeholder="Created" readonly [(ngModel)]="created">
                </mat-form-field>
                <mat-form-field *ngIf="ownerEmail">
                    <input matInput type="text" placeholder="Owner Email" readonly [(ngModel)]="ownerEmail">
                </mat-form-field>
            </div>
        </div>
    `
})
export class BriefingTeamsSettingsEditorComponent implements OnChanges {
    @Input() form : FormGroup;
    @Input() briefingId: string;
    created: string;
    ownerEmail: string;

    constructor(private datePipe: DatePipe, 
                private briefingService: BriefingService,
                private userService: UserService) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.briefingId.currentValue) {
            this.briefingService.getBriefing(changes.briefingId.currentValue)
            .pipe(
                tap(briefing => this.created = this.datePipe.transform(briefing.created, 'short')),
                mergeMap(briefing => this.userService.fetchUser(briefing.ownerId))
            )
            .subscribe(user => this.ownerEmail = user.emailAddress);
        }
    }
}